var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button is-dark is-outlined is-small",attrs:{"title":"Edit Actor details"},on:{"click":function($event){return _vm.editActor(_vm.actor)}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"lead-pencil","size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }